import React, { useState } from 'react';

type ChildrenParams = {
  visible: boolean;
  setVisible: (visible: boolean) => void;
};

export type ModalControllerProps = {
  children: (params: ChildrenParams) => React.ReactNode;
};

const ModalController = ({ children }: ModalControllerProps) => {
  const [visible, setVisible] = useState(false);

  return <>{children({ visible, setVisible })}</>;
};

export default ModalController;
